import { render, staticRenderFns } from "./ClassicPreview.vue?vue&type=template&id=87c8294e&scoped=true"
import script from "./ClassicPreview.vue?vue&type=script&lang=js"
export * from "./ClassicPreview.vue?vue&type=script&lang=js"
import style0 from "./ClassicPreview.vue?vue&type=style&index=0&id=87c8294e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87c8294e",
  null
  
)

export default component.exports